import React from 'react';
import cx from 'classnames';

/**
 * A share of a whole, as a ring with the figure that matters in the middle. `value` is what the ring is
 * counting and `percent` only how far round it goes, because the two are rarely the same thing: Insights
 * shows how many people are behind, out of how many there are.
 */
export const RingGauge = ({
  percent,
  color,
  caption,
  value,
  className,
}: {
  percent: number;
  color: string;
  caption?: string;
  value?: string;
  className?: string;
}): React.ReactElement => {
  const radius = 38;
  const circumference = 2 * Math.PI * radius;
  const filled = (Math.min(Math.max(percent, 0), 100) / 100) * circumference;

  return (
    <div className={cx('relative inline-flex items-center justify-center', className)}>
      <svg width={100} height={100} viewBox="0 0 100 100" aria-hidden>
        <circle cx={50} cy={50} r={radius} fill="none" strokeWidth={9} style={{ stroke: 'var(--border)' }} />
        <circle
          cx={50}
          cy={50}
          r={radius}
          fill="none"
          strokeWidth={9}
          style={{ stroke: color, strokeDasharray: `${filled} ${circumference}` }}
          transform="rotate(-90 50 50)"
        />
      </svg>
      <div className="absolute flex flex-col items-center leading-none">
        <span className="text-xl font-bold text-foreground">{value ?? `${percent}%`}</span>
        {caption && <span className="mt-1 text-[10px] text-muted-foreground">{caption}</span>}
      </div>
    </div>
  );
};
